(function () {
  var lightbox = document.getElementById('kitchen-lightbox');
  if (!lightbox) return;

  var titleEl = lightbox.querySelector('.kitchen-lightbox__title');
  var imageWrap = lightbox.querySelector('.kitchen-lightbox__image-wrap');
  var counterEl = lightbox.querySelector('.kitchen-lightbox__counter');
  var prevBtn = lightbox.querySelector('.kitchen-lightbox__prev');
  var nextBtn = lightbox.querySelector('.kitchen-lightbox__next');

  var currentImages = [];
  var currentIndex = 0;
  var lastFocusedEl = null;

  function renderImage() {
    // Solo aquí se crea el <img>, por lo que el navegador no descarga
    // ninguna imagen del pasador hasta que el usuario la visualiza.
    imageWrap.innerHTML = '';
    var img = document.createElement('img');
    img.src = currentImages[currentIndex];
    img.alt = titleEl.textContent + ' - imagen ' + (currentIndex + 1);
    imageWrap.appendChild(img);
    counterEl.textContent = (currentIndex + 1) + ' / ' + currentImages.length;

    var hasMultiple = currentImages.length > 1;
    prevBtn.style.display = hasMultiple ? '' : 'none';
    nextBtn.style.display = hasMultiple ? '' : 'none';
  }

  function openLightbox(images, title, triggerEl) {
    if (!images || !images.length) return;
    currentImages = images;
    currentIndex = 0;
    titleEl.textContent = title || '';
    lastFocusedEl = triggerEl || null;

    renderImage();
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    lightbox.querySelector('.kitchen-lightbox__close').focus();
  }

  function closeLightbox() {
    lightbox.hidden = true;
    imageWrap.innerHTML = ''; // libera las imágenes cargadas
    document.body.style.overflow = '';
    if (lastFocusedEl) lastFocusedEl.focus();
  }

  function showPrev() {
    currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
    renderImage();
  }

  function showNext() {
    currentIndex = (currentIndex + 1) % currentImages.length;
    renderImage();
  }

  document.querySelectorAll('.kitchen-item').forEach(function (item) {
    item.addEventListener('click', function () {
      var images = [];
      try {
        images = JSON.parse(item.dataset.images || '[]');
      } catch (e) {
        images = [];
      }
      openLightbox(images, item.dataset.title, item);
    });
  });

  lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
    el.addEventListener('click', closeLightbox);
  });

  prevBtn.addEventListener('click', showPrev);
  nextBtn.addEventListener('click', showNext);

  document.addEventListener('keydown', function (e) {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showPrev();
    if (e.key === 'ArrowRight') showNext();
  });
})();
